import React from "react";
import { styled } from '@mui/styles';

import {
    Grid,
    List,
    ListItemText,
    ListItem as MuiListItem
} from "@mui/material";

const Wrapper = styled('div')(({ theme }) => ({
    padding: `${theme.spacing(1) / 4}px ${theme.spacing(4)}px`,
    position: 'relative'
}));

const ListItem = styled(MuiListItem)(({ theme }) => ({
    display: 'inline-block',
    width: 'auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&, &:hover, &:active':  {
        color: '#555'
    }
}));

function Footer() {
    return (
        <Wrapper>
            <Grid container spacing={0}>
                <Grid container size={{ xs: 12, md: 6 }} justifyContent="flex-end">
                    <List>
                        <ListItem>
                            <ListItemText primary={`© ${new Date().getFullYear()} - WorkNest`} />
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </Wrapper>
    );
}

export default Footer;
